import { useLibraryItems } from '../../hooks/useLibraryItems'
import { useUserSubscriptions } from '../../hooks/useUserSubscriptions'
import MyBooksCard from '../../components/library/MyBooksCard'
import MySubscriptionsCard from '../../components/library/MySubscriptionsCard'

/**
 * Main Moja Biblioteka dashboard.
 *
 * Phase F3: two-column layout with scrollable "Moje książki" and
 * "Moje subskrypcje" cards. Mobile stacks vertically.
 */
export default function LibraryMainPage() {
  const { items, loading: itemsLoading } = useLibraryItems()
  const {
    subscriptions,
    loading: subsLoading,
    completePayment,
  } = useUserSubscriptions()

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <MyBooksCard items={items} loading={itemsLoading} />
      <MySubscriptionsCard
        subscriptions={subscriptions}
        loading={subsLoading}
        onCompletePayment={completePayment}
      />
    </div>
  )
}
